import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading_users: false,
    loading_video: false,
    loading_tracks: false,
    date: {},
    new_users: [],
    filterUser: 'default',
    ColumnChart: {
      width: 'auto',
      height: 330,
      colors: ['#B6B0BF'],
      fontName: 'Nunito Regular',
      isStacked: true,
      legend: { position: 'none', maxLines: 5 },
      bar: { groupWidth: '75%' },
      chartArea: {
        left: '0',
        top: '4%',
        width: '100%',
        height: '70%',
      },
      annotations: {
        alwaysOutside: true
      }
    },
  },

  mutations: {
    setLoadingNewSignups(state, payload) {
      state.loading_users = payload
    },
    setNewSignupsData(state, payload) {
      state.new_users = payload
    },
    setDate(state, payload) {
      state.date = payload
    },
    setFilterUser(state, payload) {
      state.filterUser = payload
    }
  },

  actions: {
    readNewSignups({ commit, state }, data) {
      commit('setLoadingNewSignups', true)
      axios.admin
        .get(`statistics/cid/new-signups/${state.date.date_start}/${state.date.date_end}?type=${state.filterUser}`)
        .then(r => {
          //console.log(r.data.data)
          commit('setNewSignupsData', r.data.data)
          commit('setLoadingNewSignups', false)
        })
        .catch(() => {
          commit('setLoadingNewSignups', false)
        })
    },
  },

  getters: {
    users_chart: state => {
      let result = [];
      let result2 = [];
      if (state.new_users.length > 0) {
        result = [["Element", "Totals", { role: "style" }, "Parts", { role: "style" }, { role: "annotation" }]];
        state.new_users.forEach(s => {
          result.push(["Total", Number(s.total), "#73d40c", 0, "#73d40c", Number(s.total)]),
          result.push(["CID", Number(s.cid), "#D40C41", 0, "#D40C41", Number(s.cid)]),
          result.push(["Distro", Number(s.distro), "#d4a50c", 0, "#d4a50c", Number(s.distro)]),
          result.push(["Approved (CID/Dist)", Number(s.approved) - Number(s.approved_cid), "#d4a50c", Number(s.approved_cid), "#D40C41", Number(s.approved)])
          // result.push([["Approved", Number(s.approved), "#b9d40c", Number(s.approved)], ["Batman", Number(s.approved), "#b9d40c", Number(s.approved)]])
          // result.push(["Ingested", Number(s.ingested), "#b9d40c", Number(s.ingested)])
        });
        console.log(result);
      }
   
      return result;
    },
    getFilterUser(state) {
      return state.filterUser
    }
  }
}
